module.exports = __webpack_public_path__ + "img/Advantage2.738b152c.png";